// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".markImage {\n  padding: 0px !important;\n  text-align: center;\n  font-size: 20px;\n}\n.q-img__content .markImage.active {\n  border-width: 2px !important;\n  border-style: dashed !important;\n  border-color: hsl(0, 95%, 35%) !important;\n}", ""]);
// Exports
module.exports = exports;
